module.exports = __webpack_public_path__ + "img/selected0-min.70e2f776.png";